import { render } from "./VaChart.vue?vue&type=template&id=c5d2e90e"
import script from "./VaChart.vue?vue&type=script&lang=js"
export * from "./VaChart.vue?vue&type=script&lang=js"

import "./VaChart.vue?vue&type=style&index=0&id=c5d2e90e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__